'use strict';

var ToNumber = require('./ToNumber');

// http://262.ecma-international.org/5.1/#sec-9.6

module.exports = function ToUint32(x) {
	return ToNumber(x) >>> 0;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/ToUint32.js
// module id = 548
// module chunks = 0